import { render, staticRenderFns } from "./SubjectOptionTable.vue?vue&type=template&id=2b5474fa&scoped=true&"
import script from "./SubjectOptionTable.vue?vue&type=script&lang=js&"
export * from "./SubjectOptionTable.vue?vue&type=script&lang=js&"
import style0 from "./SubjectOptionTable.vue?vue&type=style&index=0&id=2b5474fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5474fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
